import { State } from "src/state";

export const getRequestProgress = (state: State) => state.requestProgress;



// WEBPACK FOOTER //
// ./src/requestProgress/selector.ts